<template>
     <Form :model="formData" label-position="top">

        	<Row :gutter="20">
             <Col :span="6">
             <FormItem label="LOGO">
           <div  style="width:100%;height:90px;border:1px solid var(--border);border-radius:5px;">
              <GFormImageClip v-model="formData.logo" :editable="true"
            :option="{
              uploader:'session/upload'
            }"/>
              </div>
              </FormItem>
            </Col>

            <Col :span="18">
            <Row :gutter="20">
              <Col :span="24">
                <FormItem required label="名称" prop="name">
                <Input v-model="formData.name" clearable />
              </FormItem>
              </Col>
            <Col :span="24">
              <FormItem label="厂商" prop="company_id">
                 <Select v-model="formData.company_id" clearable filterable>
                  <Option v-for="c in companies" :key="'com_'+c.id" :label="c.name" :value="c.id">
                    <div>{{c.name}}
                      <div style="color:var(--sub-text3);font-size:12px;">{{c.address}}</div>
                    </div>

                  </Option>
                </Select>
              </FormItem>
            </Col>
            <Col :span="24">
              <FormItem label="档次" prop="grade">
                <Input  v-model="formData.grade" clearable />
              </FormItem>
            </Col>
            <Col :span="24">
              <FormItem label="供给周期" prop="supply_period">
                <Input  v-model="formData.supply_period" clearable />
              </FormItem>
            </Col>

             <Col :span="24">
              <FormItem label="简介" prop="description">
                <Input type="textarea" :rows="4" v-model="formData.description" clearable />
              </FormItem>
            </Col>
          </Row>

            </Col>

          </Row>
          <div class="flex-wrap flex-right">
          <Button type="primary" style="margin-right:10px" @click="handleSubmit">提交</Button>
						<Button @click="$emit('on-cancel')">取消</Button>
				</div>
      </Form>
</template>

<script>

import GFormImageClip from '@/components/form/ImageClip';
import {mapGetters} from 'vuex';
import {cloneDeep} from 'lodash';
import UTIL from '@/utils';
export default {
  data() {
    return {
      origin: {},
      formData: {},
    };
  },
  components: {GFormImageClip},
  props: {
    company_id: {
      type: String,
    },
  },
  mounted() {
    this.formData.company_id = this.company_id;
    this.$store.dispatch('mat/getCompanies');
  },
  computed: {
    ...mapGetters('mat', ['companies', 'grouped_types']),
  },
  methods: {
    handleSubmit() {
      if (this.formData.id) {
        const updateData = UTIL.compare_patch_object(this.origin, this.formData, ['name', 'logo', 'description', 'company_id']);
        this.$api.patch('mat/brands/'+this.formData.id, this.formData).then((res)=>{
          this.$emit('on-success', this.formData);
        }).catch(this.Error);
      } else {
        this.$api.post('mat/brands', this.formData).then((res)=>{
          this.$emit('on-success', res.data.data.id);
        }).catch(this.Error);
      }
    },
    setData(v) {
      this.formData = cloneDeep(v);
    },
  },
};
</script>
